// project imports
import { getVisualDepth } from '../visualDepth';

// ==============================|| OVERRIDES - DIALOG ACTIONS ||============================== //
// Modal footer: background, separator. Buttons in dialogs: ALL CAPS; visible border on secondary.
// Cancel/Close (non-contained) use neutral text color from theme, not primary/success. Applied app-wide.
// Action buttons (Cancel / Save / Update / Discard) use a wide gap so mis-clicks are less likely.

export default function DialogActions(theme) {
  const vd = getVisualDepth(theme);
  const sectionBorder = vd.dialogSectionBorder ?? (theme.palette.modal?.divider || 'rgba(0,0,0,0.24)');

  return {
    MuiDialogActions: {
      styleOverrides: {
        root: {
          padding: '16px 24px',
          borderTop: `1px solid ${sectionBorder}`,
          background: '#FAFAFA',
          // 32px between Cancel and primary — safer than MUI default (~8px).
          gap: theme.spacing(4),
          // Drop MUI's sibling marginLeft so it does not stack on top of gap.
          '& > :not(style) ~ :not(style)': {
            marginLeft: 0
          },
          '& .MuiButton-root': {
            textTransform: 'uppercase'
          },
          '& .MuiButton-root:not(.MuiButton-contained)': {
            color: theme.palette.text.primary,
            border: '1px solid rgba(0,0,0,0.24)',
            '&:hover': {
              border: '1px solid rgba(0,0,0,0.4)'
            }
          }
        }
      }
    }
  };
}
